import React, { useEffect, useState } from "react";
import { FormControl, Grid, MenuItem, Paper, Select } from "@mui/material";
import { styled } from "@mui/material/styles";
import moment from "moment";
import { CommonGridItem } from "./CommonGridItem";
const GridContainerWrapper = styled("footer")(({ theme }) => {
    return {
        ".label-container": {
            height: "49px",
            marginTop: "4px",
            flexGrow: "0",
            fontFamily: "Roboto",
            fontSize: "1.1vw",
            fontWeight: "500",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: "normal",
            letterSpacing: "1.12px",
            textAlign: "left",
            color: "#8c827a",
            display: "table",
            maxWidth: "100px",
        },
        ".label-details": {
            flexGrow: "0",
            marginTop: "4px",
            fontFamily: "Roboto",
            fontSize: "1.3vw",
            fontWeight: "400",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: "normal",
            letterSpacing: "normal",
            textAlign: "left",
            color: "#000000",
            wordBreak: "break-word",
        },
        ".imageSpin": {
            position: "absolute",
            WebkitAnimation: "spin 0.5s linear infinite",
            MozAnimation: "spin 0.5s linear infinite",
            animation: "spin 0.5s linear infinite",
        },
    };
});
const Item = styled(Paper)(({ theme }) => (Object.assign(Object.assign({ backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff" }, theme.typography.body2), { padding: theme.spacing(1), textAlign: "center", color: theme.palette.text.secondary, marginLeft: "4%", marginRight: "4%" })));
export const GridContainer = (props) => {
    var _a, _b;
    const [selectChannel, setSelectedChannel] = useState(props.CommonSelectProps.value || '');
    useEffect(() => {
        if (!selectChannel && props.CommonSelectProps.options.length > 0) {
            setSelectedChannel(props.CommonSelectProps.options[0].clientName);
        }
    }, [props.CommonSelectProps.options]);
    return (React.createElement(GridContainerWrapper, null,
        React.createElement(Item, { style: props.role == 'isSupervisor' ? Object.assign(Object.assign({}, props.itemStyle), { width: "200px" }) : props.itemStyle },
            React.createElement(Grid, { container: true, spacing: 1, xs: 12, sm: 12, md: 12, lg: 12, style: {
                    height: "auto",
                    display: "flex",
                    justifyContent: "space-between",
                } },
                React.createElement(Grid, { item: true, xs: 4, sm: 6, md: props.role == 'isSupervisor' ? 12 : 2 },
                    React.createElement("div", { className: "label-container" }, props.inputBoxTitle),
                    React.createElement(FormControl, { fullWidth: props.CommonSelectProps.fullWidth },
                        React.createElement(Select, { value: props.CommonSelectProps.value, id: props.CommonSelectProps.id, variant: "standard", sx: props.CommonSelectProps.sx, onChange: props.CommonSelectProps.onChange }, (_a = props.CommonSelectProps) === null || _a === void 0 ? void 0 : _a.options.map((option) => (React.createElement(MenuItem, { key: option.clientName, value: option.clientName },
                            React.createElement("span", { style: { fontSize: "1.2vw" } }, option.clientName))))))),
                props.role != 'isSupervisor' && ((_b = props === null || props === void 0 ? void 0 : props.gridData) === null || _b === void 0 ? void 0 : _b.map((item, index) => (React.createElement(CommonGridItem, { key: index, label: item.label, value: item.value, isNegative: item.isNegative, formatValue: item.formatValue, color: item.color })))),
                props.role != 'isSupervisor' &&
                    React.createElement(Grid, { item: true, xs: 4, sm: 6, md: 1 },
                        React.createElement("div", { className: "label-container", style: { fontSize: 9 } },
                            props.CommonRefreshProps.title,
                            React.createElement("br", null),
                            props.CommonRefreshProps.timeNow &&
                                moment(new Date(props.CommonRefreshProps.lastRefreshTime))
                                    .fromNow()
                                    .replace("a few seconds", "0 minute"),
                            React.createElement("br", null),
                            React.createElement("img", { style: {
                                    width: "23.7px",
                                    height: "23.1px",
                                    cursor: props.CommonRefreshProps.loaderCommission
                                        ? "wait"
                                        : "pointer",
                                    marginTop: 7,
                                    marginLeft: 15,
                                }, className: props.CommonRefreshProps.loaderCommission ? "imageSpin" : "", src: require("../../assests/images/reload.png"), onClick: () => {
                                    if (!props.CommonRefreshProps.loaderCommission) {
                                        props.CommonRefreshProps.onRefresh();
                                    }
                                } })))))));
};
